const bookletForParentsFutureFirstGraders =
    "/docs/guidelines/prevention/Буклет_для_родителей_будущих_первоклассников.pdf";
const hotlinesForParents = "/docs/guidelines/prevention/Горячие_линии_для_родителей.pdf";
const destructiveBehaviorTeachers =
    "/docs/guidelines/prevention/Деструктивное_поведение_Алгоритм_действий_для_педагогов.pdf";
const destructiveBehaviorParents =
    "/docs/guidelines/prevention/Деструктивное_поведение_Алгоритм_действий_для_родителей.pdf";
const childHelpline = "/docs/guidelines/prevention/Детский_телефон_доверия.pdf";
const morningKindWords = "/docs/guidelines/prevention/Картотека_Добрые_слова_с_утра.pdf";
const interviewGuideForChildren = "/docs/guidelines/prevention/Памятка_для_детей_Собеседования.pdf";
const psychologicalPreparationForParents =
    "/docs/guidelines/prevention/Памятка_для_родителей_Как_психологически_подготовить_ребенка_к_учебе.pdf";
const dailyRoutineForParents =
    "/docs/guidelines/prevention/Памятка_для_родителей_Режим_дня_будущего_первоклассника.pdf";
const developmentLevelForParents =
    "/docs/guidelines/prevention/Памятка_для_родителей_Уровень_развития_психических_процессов_у_первоклассника.pdf";
const zprMemo = "/docs/guidelines/prevention/Памятка_ЗПР.pdf";
const responseToChildProvocation = "/docs/guidelines/prevention/Памятка_Как_реагировать_на_провокации_детей.pdf";
const dealingWithBullying = "/docs/guidelines/prevention/Памятка_Как_родителям_справиться_с_буллингом.doc";
const visionDisordersMemo = "/docs/guidelines/prevention/Памятка_Нарушение_зрения.pdf";
const hearingDisordersMemo = "/docs/guidelines/prevention/Памятка_Нарушения_слуха.pdf";
const nodaMemo = "/docs/guidelines/prevention/Памятка_НОДА.pdf";
const preventionMemo = "/docs/guidelines/prevention/Памятка_по_выявлению_и_предупреждению.pdf";
const rasMemo = "/docs/guidelines/prevention/Памятка_РАС.pdf";
const stressCopingMemo = "/docs/guidelines/prevention/Памятка_справиться_со_стрессом.pdf";
const selfHelpTechniquesMemo = "/docs/guidelines/prevention/Памятка_Техники_самопомощи.pdf";
const tmnrAndUoMemo = "/docs/guidelines/prevention/Памятка_ТМНР_и_УО.pdf";
const tnrMemo = "/docs/guidelines/prevention/Памятка_ТНР.pdf";
const difficultiesForFirstGrader =
    "/docs/guidelines/prevention/Памятка_Трудности_с_которыми_может_столкнуться_первоклассник.pdf";
const posterForParentsBeforeSchool = "/docs/guidelines/prevention/Плакат_для_родителей_Перед_школой.pdf";
const schoolShootingPrevention =
    "/docs/guidelines/prevention/Предотвращение_деструктивных_проявлений_в_форме_скулшутинга_в_школе.pdf";
const childVictimOfBullying = "/docs/guidelines/prevention/Ребенок_жертва_буллинга.docx";
const schoolBullying = "/docs/guidelines/prevention/Травля_в_школе.pdf";
const checklistForParentsBeforeSchool = "/docs/guidelines/prevention/Чек_лист_для_родителей_До школы.pdf";

export const preventionReminders = {
    files: [
        {
            title: "Буклет для родителей будущих первоклассников",
            file: bookletForParentsFutureFirstGraders,
            fileName: "Буклет_для_родителей_будущих_первоклассников.pdf",
        },
        {
            title: "Горячие линии для родителей",
            file: hotlinesForParents,
            fileName: "Горячие_линии_для_родителей.pdf",
        },
        {
            title: "Алгоритм действий для педагогов при деструктивном поведении",
            file: destructiveBehaviorTeachers,
            fileName: "Деструктивное_поведение_Алгоритм_действий_для_педагогов.pdf",
        },
        {
            title: "Алгоритм действий для родителей при деструктивном поведении",
            file: destructiveBehaviorParents,
            fileName: "Деструктивное_поведение_Алгоритм_действий_для_родителей.pdf",
        },
        {
            title: "Детский телефон доверия",
            file: childHelpline,
            fileName: "Детский_телефон_доверия.pdf",
        },
        {
            title: "Добрые слова с утра",
            file: morningKindWords,
            fileName: "Картотека_Добрые_слова_с_утра.pdf",
        },
        {
            title: "Памятка для детей: Собеседования",
            file: interviewGuideForChildren,
            fileName: "Памятка_для_детей_Собеседования.pdf",
        },
        {
            title: "Памятка для родителей: Как психологически подготовить ребенка к учебе",
            file: psychologicalPreparationForParents,
            fileName: "Памятка_для_родителей_Как_психологически_подготовить_ребенка_к_учебе.pdf",
        },
        {
            title: "Памятка для родителей: Режим дня будущего первоклассника",
            file: dailyRoutineForParents,
            fileName: "Памятка_для_родителей_Режим_дня_будущего_первоклассника.pdf",
        },
        {
            title: "Памятка для родителей: Уровень развития психических процессов у первоклассника",
            file: developmentLevelForParents,
            fileName: "Памятка_для_родителей_Уровень_развития_психических_процессов_у_первоклассника.pdf",
        },
        {
            title: "Памятка ЗПР",
            file: zprMemo,
            fileName: "Памятка_ЗПР.pdf",
        },
        {
            title: "Как реагировать на провокации детей",
            file: responseToChildProvocation,
            fileName: "Памятка_Как_реагировать_на_провокации_детей.pdf",
        },
        {
            title: "Как родителям справиться с буллингом",
            file: dealingWithBullying,
            fileName: "Памятка_Как_родителям_справиться_с_буллингом.doc",
        },
        {
            title: "Памятка: Нарушение зрения",
            file: visionDisordersMemo,
            fileName: "Памятка_Нарушение_зрения.pdf",
        },
        {
            title: "Памятка: Нарушения слуха",
            file: hearingDisordersMemo,
            fileName: "Памятка_Нарушения_слуха.pdf",
        },
        {
            title: "Памятка НОДА",
            file: nodaMemo,
            fileName: "Памятка_НОДА.pdf",
        },
        {
            title: "Памятка по выявлению и предупреждению",
            file: preventionMemo,
            fileName: "Памятка_по_выявлению_и_предупреждению.pdf",
        },
        {
            title: "Памятка РАС",
            file: rasMemo,
            fileName: "Памятка_РАС.pdf",
        },
        {
            title: "Памятка: Как справиться со стрессом",
            file: stressCopingMemo,
            fileName: "Памятка_справиться_со_стрессом.pdf",
        },
        {
            title: "Памятка: Техники самопомощи",
            file: selfHelpTechniquesMemo,
            fileName: "Памятка_Техники_самопомощи.pdf",
        },
        {
            title: "Памятка ТМНР и УО",
            file: tmnrAndUoMemo,
            fileName: "Памятка_ТМНР_и_УО.pdf",
        },
        {
            title: "Памятка ТНР",
            file: tnrMemo,
            fileName: "Памятка_ТНР.pdf",
        },
        {
            title: "Памятка: Трудности, с которыми может столкнуться первоклассник",
            file: difficultiesForFirstGrader,
            fileName: "Памятка_Трудности_с_которыми_может_столкнуться_первоклассник.pdf",
        },
        {
            title: "Плакат для родителей перед школой",
            file: posterForParentsBeforeSchool,
            fileName: "Плакат_для_родителей_Перед_школой.pdf",
        },
        {
            title: "Предотвращение деструктивных проявлений в форме скулшутинга в школе",
            file: schoolShootingPrevention,
            fileName: "Предотвращение_деструктивных_проявлений_в_форме_скулшутинга_в_школе.pdf",
        },
        {
            title: "Ребенок жертва буллинга",
            file: childVictimOfBullying,
            fileName: "Ребенок_жертва_буллинга.docx",
        },
        {
            title: "Травля в школе",
            file: schoolBullying,
            fileName: "Травля_в_школе.pdf",
        },
        {
            title: "Чек-лист для родителей: До школы",
            file: checklistForParentsBeforeSchool,
            fileName: "Чек_лист_для_родителей_До школы.pdf",
        },
    ],
};
